










import { Vue, Component } from 'vue-property-decorator';
import Tarifas from '@/pantallas/Peajes/Tarifas/Tarifas.vue';

@Component({
  components: { Tarifas },
})
export default class TarifasPantalla extends Vue {}
